import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    BehaviorSubject,
    interval,
    forkJoin,
    from,
    Observable,
    of,
    Subject,
} from 'rxjs';
import { environment } from '../../../../environments/environment';
import { LoadingController } from '@ionic/angular';
import { ContentObserver } from '@angular/cdk/observers';
import { SwUpdate } from '@angular/service-worker';
import { ModalController } from '@ionic/angular';

import { ServiceWorkerComponent } from '@app/shared/components/service-worker/service-worker.component';

// eslint-disable-next-line @typescript-eslint/naming-convention
@Injectable({
    providedIn: 'root',
})
export class WorkerService {
    showUpdateBanner = new BehaviorSubject(false);
    constructor(private modalCtrl: ModalController, public updates: SwUpdate) {
        if (updates.isEnabled) {
            interval(30000).subscribe(() =>
                updates
                    .checkForUpdate()
                    .then(() => console.log('checking for updates'))
            );
        }
    }

    public checkForUpdates(): void {
        this.updates.available.subscribe(event => this.promptUser());
    }

    async promptUser() {
        console.log('updating to new version');

        this.setShowBanner();
        // modal
        // const modal = await this.modalCtrl.create({
        //     component: ServiceWorkerComponent,
        //     backdropDismiss: false,
        //     cssClass: 'my-custom-modal-css',
        // });

        // modal.onDidDismiss().then(response => {
        //     if (response) {
        //         this.reload();
        //     }
        // });

        // return await modal.present();
    }

    reload() {
        this.updates.activateUpdate().then(() =>
            setTimeout(() => {
                document.location.reload();
            }, 1000)
        );
    }

    clearShowBanner() {
        this.showUpdateBanner.next(false);
    }
    setShowBanner() {
        this.showUpdateBanner.next(true);
    }
} // end of the tools service
